export default [
  {
    key: 'id',
    type: 'id',
  },
  {
    key: 'slug',
    label: 'Slug',
    visibility: ['view'],
  },
  {
    key: 'title',
    label: 'Judul',
  },
  {
    key: 'description',
    label: 'Deskripsi',
    visibility: ['view'],
  },
  {
    key: 'banner_url',
    label: 'Banner URL',
    visibility: ['view'],
  },
  {
    key: 'popup_url',
    label: 'Popup URL',
    visibility: ['view'],
  },
  {
    key: 'owner_merchant.name',
    label: 'Dibuat Oleh',
    type: 'profile',
    image: 'owner_merchant.image_url',
    visibility: ['view'],
  },
  {
    key: 'sale_skus_count',
    label: 'Jumlah SKU',
    type: 'number',
    suffix: ' SKU',
    visibility: ['view'],
  },
  {
    key: 'merchants_count',
    label: 'Jumlah Brand',
    type: 'number',
    visibility: ['view'],
  },
  {
    key: 'status',
    label: 'Status',
    type: 'badge',
    map: {
      inactive: 'secondary',
      ended: 'dark',
      failed_to_start: 'danger',
      failed_to_end: 'danger',
      starting: 'warning',
      ending: 'warning',
      waiting_to_start: 'warning',
      started: 'success',
    },
  },
  {
    key: 'is_active',
    label: 'Aktif',
    visibility: ['view'],
    filter: {
      key: 'is_active',
      type: 'select',
      label: 'Aktif',
      default: true,
      options: [
        {
          value: true,
          text: 'Aktif',
        },
        {
          value: false,
          text: 'Tidak aktif',
        },
      ],
    },
  },
  {
    key: 'should_started_at',
    label: 'Dimulai Pada',
    type: 'datetime',
  },
  {
    key: 'should_ended_at',
    label: 'Berakhir Pada',
    type: 'datetime',
  },
  {
    key: 'started_at',
    label: 'Telah Dimulai Pada',
    type: 'datetime',
    visibility: ['view'],
  },
  {
    key: 'ended_at',
    label: 'Telah Berakhir Pada',
    type: 'datetime',
    visibility: ['view'],
  },
  {
    key: 'created_at',
    label: 'Dibuat Pada',
    type: 'datetime',
    visibility: ['view'],
  },
]
